var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.card.flipped,staticClass:"card"},[_c('img',{attrs:{"src":_vm.card.flipped ? _vm.card.image : 'assets/images/cardback.svg',"height":"160px","width":"180px"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.card.flipped),expression:"card.flipped"}]},[_vm._v(_vm._s(_vm.card.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db968792","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-matching-card.vue
// module id = 143
// module chunks = 0